import { AppUtil, EnvUtil } from 'kuaidong-lib'
import { UserTeacherId, Organization, ILoginResult, IMgmtAccountLoginResult } from 'kuaidong-model'

export class ALogin {
  static async sendLoginCode(phone: string) {
    if (EnvUtil.isISC()) {
      return AppUtil.httpGET('/classroom/login', { phone })
    }

    return AppUtil.httpPOST(
      `${process.env.VUE_APP_CRAZYROPE_API}/user/send_login_code`,
      { phone },
      {
        'X-Gkid-Appname': 'h5',
      },
      false,
      false
    )
  }

  static async sendLoginCodeV2(phone: string, region = '86') {
    return AppUtil.httpPOST(
      `${process.env.VUE_APP_CRAZYROPE_API}2/user/send_login_code`,
      { phone, region },
      {},
      false,
      false
    )
  }

  static async logout() {
    try {
      AppUtil.removeRuquestToken()

      if (EnvUtil.isAgency()) {
        document.cookie = 'TRUID=;domain=tiantiantiaosheng.com;path=/;max-age=0'
      }

      if (EnvUtil.isCampus() || EnvUtil.isSaas()) {
        document.cookie = 'ttts_user_token=;domain=tiantiantiaosheng.com;path=/;max-age=0'
        document.cookie = 'ttts_user_token_debug=;domain=tiantiantiaosheng.com;path=/;max-age=0'

        return await AppUtil.httpGET(`/account/logout`)
      }
    } catch {
      // noop
    }
  }

  static async loginByPhone(phone: string, code: string, wx_open_id?: string): Promise<ILoginResult> {
    if (EnvUtil.isISC()) {
      return AppUtil.httpPOST('/classroom/login', { phone, code }, false, false)
    }

    const result = (await AppUtil.httpPOST(
      `${process.env.VUE_APP_CRAZYROPE_API}/user/login_wechat_h5`,
      { phone, sms_code: code, wx_open_id },
      {},
      false,
      EnvUtil.isAgency() ? false : true
    )) as ILoginResult

    AppUtil.setRequestToken(result.auth_token)

    return result
  }

  static async loginTzyByPhone(phone: string, code: string, wx_open_id?: string): Promise<ILoginResult> {
    if (EnvUtil.isISC()) {
      return AppUtil.httpPOST('/classroom/login', { phone, code }, false, false)
    }

    const result = (await AppUtil.httpPOST(
      EnvUtil.isCampus()
        ? `${process.env.VUE_APP_API}/user/login_wechat_h5`
        : `${process.env.VUE_APP_CRAZYROPE_API}/user/login_wechat_h5`,
      { phone, sms_code: code, wx_open_id },
      {},
      false,
      EnvUtil.isAgency() ? false : true
    )) as ILoginResult

    AppUtil.setRequestToken(result.auth_token)

    return result
  }

  static async bindWxWork() {
    await AppUtil.httpPOST(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/swk/user/bind_user_id`)
  }

  public static async loginByH5Token(): Promise<UserTeacherId> {
    return AppUtil.httpGET('/account/login_by_h5token', {}, {}, true)
  }

  static async loginByQrCode(token: string) {
    return (await AppUtil.httpPUT('/account/qrcode_login', { token })).status
  }

  static async loginByQrCodeResult(token: string, expiredDays?: number | null): Promise<boolean> {
    return (await AppUtil.httpPOST('/account/qrcode_login', { token, expires_days: expiredDays })).login
  }

  static async loginByQrCodeToken(): Promise<string> {
    return (await AppUtil.httpGET('/account/qrcode_login')).token
  }

  // 其他账号系统
  /** 机构/管理账号登录 */
  static async loginByAccount(username: string, password: string): Promise<IMgmtAccountLoginResult> {
    return AppUtil.httpPOST('/mgmt/account/login', { login_name: username, password })
  }

  static async getOrganizationInfo(): Promise<Organization> {
    return AppUtil.httpGET('/mgmt/account/login')
  }
}
